import type { PusherPrivateChannel } from '@shared/api'

import { leaveChannel, listenChannel, stopListeningEvent, useChannel } from '@shared/api'

import { useDisciplinePrivileges } from '../discipline-privileges.hook'
import { useLessonsRefresh } from './lessons-refresh.hook'

const RECURRING_DONE_EVENT = '.discipline.bookings.recurring.done'
const RECURRING_FAILED_EVENT = '.discipline.bookings.recurring.failed'

/**
 * The recurring job, queued by the weekly schedule or by activation, reports on the discipline channel; the list is
 * reread either way. Joining needs view-disciplines: without it the list simply is not refreshed live.
 */
export const useLessonsRecurringEvents = (): void => {
  const route = useRoute()
  const { canViewDisciplines } = useDisciplinePrivileges()
  const { refreshLessons } = useLessonsRefresh()

  const disciplineId = Number(route.params.id)
  const channelName = `admin.discipline.${disciplineId}`

  let channel: PusherPrivateChannel | null = null

  const onFinished = (): void => {
    void refreshLessons()
  }

  onMounted(() => {
    if (!canViewDisciplines.value) return

    channel = useChannel(channelName)
    listenChannel(channel, RECURRING_DONE_EVENT, onFinished)
    listenChannel(channel, RECURRING_FAILED_EVENT, onFinished)
  })

  onBeforeUnmount(() => {
    if (!channel) return

    stopListeningEvent(channel, RECURRING_DONE_EVENT, onFinished)
    stopListeningEvent(channel, RECURRING_FAILED_EVENT, onFinished)
    leaveChannel(channelName)
    channel = null
  })
}
